export default __webpack_public_path__ + "static/women-bodymap-face-2-1244e017c82047ffc9e42be67b97b07c.webp";